<template>
  <div class="maint-wrap">
    <!-- 배경이미지 컨테이너(PC/모바일 자동 전환) -->
    <div class="maint-art" :class="{ mobile: isMobile }">
    </div>
    <div class="btn-area">
      <button type="button:" class="btn-main" @click="goHome">메인으로 이동</button>
      <button type="button" class="btn-back" @click="goBack">이전 페이지</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFoundView",
  data() {
    return {
      isMobile: false,
    };
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push('/');
      }
    },
    goHome() {
      this.$store.commit('setCprsvInfo', '')
      this.$store.commit('setCprsv', '')
      this.$store.commit('init')
      this.$store.commit('setReserveInfo', '')
      this.$store.commit('setReserve', '')
      location.href = '/'
    }
  },
  mounted() {
    const mq = window.matchMedia("(max-width: 768px)");
    this.isMobile = mq.matches;
    mq.addEventListener?.("change", e => (this.isMobile = e.matches));
  },
};
</script>

<style scoped>
/* 화면 꽉 채우고 스크롤/여백 제거 */
.maint-wrap{
  position: fixed;
  inset: 0;
  overflow: hidden;
}

/* 컨테이너 자체를 전체 화면로 → 파란 여백 사라짐 */
.maint-art{
  position: relative;
  width: 100%;
  height: 100%;
  background: #fff center / cover no-repeat
              url("@/assets/resource/img/not_found.png"); /* 기본 PC */
}

/* 모바일은 모바일 이미지를 배경으로 */
.maint-art.mobile{
  background-image: url("@/assets/resource/img/not_found_mo.png");
  background-size: contain;
}

/* PC 핫스팟: QR 코드 위치를 덮는 투명 링크 */
/* 아래 좌표/크기는 퍼센트로, 필요시 미세조정 */
.hotspot{
  position: absolute;
  z-index: 2;
  /* 대략 중앙 하단의 QR 위치(1920x1080 기준) */
  left: 50%;
  top: 71%;
  width: 6.2%;
  height: 11%;
  transform: translate(-50%, -50%);
  /* 개발 중 위치 확인용: 필요 시 켜고 조정 후 주석 처리 */
  /* outline: 2px dashed rgba(0,0,0,.2); */
}

/* 모바일은 전체 영역 클릭 */
.mobile-cover{
  position: absolute;
  inset: 0;
  z-index: 2;
  /* outline: 2px solid red; */
}

.btn-area {
  position: absolute;
  top: 65%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 16px;
  z-index: 10;
  white-space: nowrap;
}

.btn-main, .btn-back {
  min-width: 180px;
  width:280px;
  height: 70px;
  border-radius: 12px;
  font-size: 17px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  border: none;
}

.btn-main {
  background: #2f67d8;
  color: #fff;
}

.btn-back {
  background: #fff;
  color: #333;
  border: 1px solid #d0d7e2;
}

@media (max-width: 768px) {
  .btn-area {
    top: 65%;
    gap: 10px;
    width: calc(100% - 40px);
    justify-content: center;
  }

  .btn-main, .btn-back {
    flex: 1;
    min-width: 0;
    max-width: 180px;
    height: 48px;
    font-size: 15px;
  }
}
</style>
